export enum AdditionalTabNameEnum {
  ENABLED_FEATURES = 'Enabled Features',
  ALL = 'All',
}
